// extracted by mini-css-extract-plugin
module.exports = {"factFictionButtons":"FactOrFictionButtons_factFictionButtons__1zcIx","or":"FactOrFictionButtons_or__zlxk-"};